
export default {
  state: {
    userInfo: null,
    accesToken: null,
    role: null,
    allRoles: null
  },
  getters: {
    isLoggedIn: state => !!state.accesToken,
    isAdmin: state => state.role === 'ADMIN',
    isConstructor: state => state.role === 'CONSTRUCTOR'
  },
  mutations: {
    auth_success (state, payload) {
      state.accesToken = payload.token
      state.userInfo = payload.user
    },
    logout (state) {
      state.accesToken = null
      state.userInfo = null
      state.role = null
    },
    setRoles (state, payload) {
      state.allRoles = payload.map((el, index) => {
        return { id: index, label: el }
      })
    }
  },
  actions: {
    async resetPassword ({ commit, rootState, state }, id) {
      const resetPassword = await fetch(`${rootState.api.host}${rootState.api.endpoint.users}/${id}/reset-password`, {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json;charset=utf-8',
          Authorization: 'Bearer ' + state.accesToken
        }
      })
      if (resetPassword.ok) {
        const response = await resetPassword.json()
        return response
      } else {
        commit('notifications/addNotification', {
          notification: {
            type: 'danger',
            message: 'Failed to reset password, please try again later'
          }
        }, { root: true })
        return false
      }
    },
    async saveUser ({ commit, rootState, state }, data) {
      const saveUser = await fetch(`${rootState.api.host}${rootState.api.endpoint.users}/${data.id}`, {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json;charset=utf-8',
          Authorization: 'Bearer ' + state.accesToken
        },
        body: JSON.stringify(data)
      })
      if (saveUser.ok) {
        commit('notifications/addNotification', {
          notification: {
            type: 'success',
            message: 'User data updated'
          }
        }, { root: true })
        return true
      } else {
        const response = await saveUser.json()
        for (const key in response.errors) {
          commit('notifications/addNotification', {
            notification: {
              type: 'danger',
              message: response.errors[key].join(' ')
            }
          }, { root: true })
        }
        return false
      }
    },
    async getUsers ({ state, rootState, commit }, data) {
      const getUsers = await fetch(`${rootState.api.host}${rootState.api.endpoint.users}?page=${data.page}&page_size=${data.page_size}`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json;charset=utf-8',
          Authorization: 'Bearer ' + state.accesToken
        }
      })
      if (getUsers.ok) {
        const users = await getUsers.json()
        const totalCount = getUsers.headers.get('x-total-count')
        return {
          users: users,
          totalCount: totalCount
        }
      } else {
        commit('notifications/addNotification', {
          notification: {
            type: 'danger',
            message: 'Users not loaded'
          }
        }, { root: true })
        return false
      }
    },
    async deleteUser ({ state, rootState, commit }, id) {
      const deleteUser = await fetch(`${rootState.api.host}${rootState.api.endpoint.users}/${id}`, {
        method: 'DELETE',
        headers: {
          'Content-Type': 'application/json;charset=utf-8',
          Authorization: 'Bearer ' + state.accesToken
        }
      })
      if (deleteUser.ok) {
        commit('notifications/addNotification', {
          notification: {
            type: 'success',
            message: 'User deleted'
          }
        }, { root: true })
        return true
      } else {
        commit('notifications/addNotification', {
          notification: {
            type: 'danger',
            message: 'User is not deleted. Try again'
          }
        }, { root: true })
        return false
      }
    },
    logout ({ commit }) {
      return new Promise((resolve, reject) => {
        commit('logout')
        resolve()
      })
    },
    async deleteInvite ({ state, rootState, commit }, id) {
      const deleteInvite = await fetch(`${rootState.api.host}${rootState.api.endpoint.invites}/${id}`, {
        method: 'DELETE',
        headers: {
          'Content-Type': 'application/json;charset=utf-8',
          Authorization: 'Bearer ' + state.accesToken
        }
      })
      if (deleteInvite.ok) {
        commit('notifications/addNotification', {
          notification: {
            type: 'success',
            message: 'Invite deleted'
          }
        }, { root: true })
        return true
      } else {
        commit('notifications/addNotification', {
          notification: {
            type: 'danger',
            message: 'Invite is not deleted. Try again'
          }
        }, { root: true })
        return false
      }
    },
    async getInvites ({ state, rootState, commit }) {
      const getInvites = await fetch(`${rootState.api.host}${rootState.api.endpoint.invites}`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json;charset=utf-8',
          Authorization: 'Bearer ' + state.accesToken
        }
      })
      if (getInvites.ok) {
        const invites = await getInvites.json()
        return invites
      } else {
        commit('notifications/addNotification', {
          notification: {
            type: 'danger',
            message: 'Invites not loaded'
          }
        }, { root: true })
        return false
      }
    },
    async sendInvites ({ commit, rootState, state }, data) {
      const sendInvites = await fetch(`${rootState.api.host}${rootState.api.endpoint.invites}`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json;charset=utf-8',
          Authorization: 'Bearer ' + state.accesToken
        },
        body: JSON.stringify(data)
      })
      if (sendInvites.ok) {
        return await sendInvites.json()
      } else {
        const response = await sendInvites.json()
        for (const key in response.errors) {
          commit('notifications/addNotification', {
            notification: {
              type: 'danger',
              message: response.errors[key].join(' ')
            }
          }, { root: true })
        }
        return false
      }
    },
    async getRoles ({ commit, state, rootState }) {
      const getRoles = await fetch(`${rootState.api.host}${rootState.api.endpoint.roles}`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json;charset=utf-8',
          Authorization: 'Bearer ' + state.accesToken
        }
      })
      if (getRoles.ok) {
        const roles = await getRoles.json()
        commit('setRoles', roles)
        return roles
      } else {
        commit('notifications/addNotification', {
          notification: {
            type: 'danger',
            message: 'Roles not loaded'
          }
        }, { root: true })
        return false
      }
    },
    login ({ commit, rootState }, user) {
      return new Promise((resolve, reject) => {
        fetch(`${rootState.api.host}${rootState.api.endpoint.login}`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json;charset=utf-8'
          },
          body: JSON.stringify({
            email: user.email,
            password: user.password
          })
        })
          .then(async (response) => {
            const data = await response.json()
            if (response.status !== 200) {
              const rejectResponceData = {
                info: response,
                body: data
              }
              return reject(rejectResponceData)
            }
            commit('auth_success', data)
            resolve(data)
          })
          .catch(err => {
            reject(err)
          })
      })
    },
    register ({ commit, rootState }, user) {
      return new Promise((resolve, reject) => {
        fetch(`${rootState.api.host}${rootState.api.endpoint.users}`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json;charset=utf-8'
          },
          body: JSON.stringify({
            name: user.name,
            email: user.email,
            password: user.password,
            invite_code: user.invite_code
          })
        })
          .then(async (response) => {
            const data = await response.json()
            if (response.status !== 200) {
              const rejectResponceData = {
                info: response,
                body: data
              }
              return reject(rejectResponceData)
            }
            commit('auth_success', data)
            resolve(data)
          })
          .catch(err => {
            reject(err)
          })
      })
    }
  }
}
